import { request, errHandler } from "./heimdall";
import store from "../store";

/* Mantis API requests */
/* Get all projects id & name */
export function getAllProjects() {
  return request
    .get(`/mantis/projects`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get initial, done & remaining time for each ticket */
export function getProjectTime({ id }) {
  return request
    .get(`/mantis/projecttime/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get projects remaining time for each ticket & each user */
export function getProjectRemainingTime({ id }) {
  return request
    .get(`/mantis/projectremainingtime/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get info according to month for each ticket */
export function getProjectMonthMonitoring({ id }) {
  return request
    .get(`/mantis/projectmonthmonitoring/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Create project into project_info db */
export function createProjectContract(params) {
  return request
    .post(`/mantis`, params, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Update project into project_info db */
export function updateProjectContract(params) {
  return request
    .put(`/mantis`, params, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get infos from monitoring datas stored in database */
export function getMonitoringInfos(data) {
  return request
    .get(`/monitorings/${data.id}`, {
      params: {
        password: data.password
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get all projects from ProjectContracts db */
export function getProjectContract() {
  return request
    .get(`/mantis/price`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get project cost infos */
export function getProjectPrice({ id }) {
  return request
    .get(`/mantis/price/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

/* Get infos from monitoring datas stored in database */
export function saveData(data) {
  return request
    .get(`/monitorings/save`, {
      params: {
        password: data.password 
      },
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}